export enum IncidentCardSubtitleType {
  Details,
  HeadlineStatus,
  Updated,
  CreatedRelative,
  UpdatedRelative
}
